import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import Cookies from "js-cookie";
import { Spin, Empty } from "antd";
import { HiOutlineStar, HiOutlineChevronLeft } from 'react-icons/hi';

function ReviewsList() {
  const history = useHistory();
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    setLoading(true);
    try {
      const doctorId = Cookies.get("Doctor_id") || Cookies.get("doctor_id") || localStorage.getItem("Doctor_id");
      if (!doctorId) return;

      const response = await axiosInstance({
        method: "POST",
        url: "doctor/getDoctorReviews",
        data: { doctorId },
      });

      if (response.data && response.data.status === 1) {
        setReviews(Array.isArray(response.data.data) ? response.data.data : []);
      }
    } catch (error) {
      console.error("Failed to fetch reviews:", error);
    } finally {
      setLoading(false);
    }
  };

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <span key={i} className={`text-sm ${i <= rating ? 'text-amber-400' : 'text-gray-200'}`}>
          ★
        </span>
      );
    }
    return stars;
  };

  return (
    <div className="space-y-3 animate-in fade-in duration-300 w-full text-gray-800">
      {/* Integrated Header Bar */}
      <div className="bg-white px-3.5 py-2.5 rounded-lg border border-gray-200 shadow-2xs flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <button 
            onClick={() => history.push("/dashboard")}
            className="p-1 hover:bg-gray-100 rounded text-gray-400 transition-colors cursor-pointer"
            title="Back to Dashboard"
          >
            <HiOutlineChevronLeft size={18} />
          </button>
          <div>
            <h2 className="text-sm font-bold text-gray-800 leading-tight">Patient Reviews</h2>
            <p className="text-gray-400 text-[11px]">Feedback and ratings submitted by your patients</p>
          </div>
        </div>
        <div className="bg-amber-50 border border-amber-200 text-amber-700 px-2.5 py-1 rounded-lg font-bold text-xs flex items-center gap-1">
          <HiOutlineStar size={14} className="text-amber-500 fill-amber-400" />
          <span>{reviews.length} Total</span>
        </div>
      </div>

      {/* Reviews List Container */}
      {loading ? (
        <div className="py-10 flex flex-col items-center justify-center gap-2 bg-white rounded-lg border border-gray-200">
          <Spin size="small" />
          <p className="text-gray-400 font-semibold text-xs">Loading patient reviews...</p>
        </div>
      ) : reviews.length === 0 ? (
        <div className="bg-white py-8 rounded-lg border border-dashed border-gray-200 flex flex-col items-center">
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<span className="text-xs font-medium text-gray-400">No patient reviews found yet</span>} />
        </div>
      ) : (
        <div className="space-y-2">
          {reviews.map((review) => (
            <div key={review.review_id || review.id} className="bg-white p-3 sm:p-3.5 border border-gray-200 rounded-lg shadow-2xs hover:shadow-xs transition-all">
              <div className="flex justify-between items-start gap-2 mb-1.5">
                <div className="flex items-center gap-2.5">
                  <div className="w-8 h-8 rounded-full overflow-hidden bg-teal-50 border border-teal-100 shrink-0 flex items-center justify-center text-teal-700 font-bold text-xs shadow-2xs">
                    {review.patient_image ? (
                      <img src={review.patient_image} alt="Patient" className="w-full h-full object-cover" />
                    ) : (
                      <span>
                        {(review.patient_name || 'A').charAt(0).toUpperCase()}
                      </span>
                    )}
                  </div>
                  <div>
                    <h4 className="font-bold text-xs text-gray-800 leading-snug">{review.patient_name || 'Anonymous Patient'}</h4>
                    <p className="text-[10px] text-gray-400 font-medium">
                      {review.created_at ? new Date(review.created_at).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }) : 'Recent'}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-0.5 bg-gray-50 px-2 py-0.5 rounded border border-gray-100">
                  {renderStars(review.rating || 5)}
                </div>
              </div>
              {review.remarks && (
                <p className="text-gray-600 text-xs leading-relaxed pt-1 border-t border-gray-50 font-normal">
                  "{review.remarks}"
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ReviewsList;
